const options = [
    {
        value: 1,
        label: '时间',
    },
    {
        value: 2,
        label: '门店',
    },
    {
        value: 3,
        label: '顾客',
    },
    {
        value: 4,
        label: '会员',
    },
    {
        value: 5,
        label: '客流渠道',
    },
    {
        value: 6,
        label: '预约渠道',
    },
    {
        value: 7,
        label: '项目',
    },
    {
        value: 8,
        label: '储值卡',
    },
    {
        value: 9,
        label: '理疗师',
    },
    {
        value: 8,
        label: '储值卡',
    },
    {
        value: 8,
        label: '储值卡',
    },
    {
        value: 8,
        label: '储值卡',
    },
    {
        value: 8,
        label: '储值卡',
    },
    {
        value: 14,
        label: '渠道',
    },
]
// 卡相关页面专用 options：去掉储值卡占位项，后端暂无对比规则
const cardTrendOptions = options.map((item, i) => i === 12 ? null : item)
const cardNoCompareOptions = options.map((item, i) => i === 7 ? null : item)
// LE-5997 人群销售趋势对比维度：复制 options，在筛选下标 15 追加"国际特征"（compareType=10 由 two_header 的 changeIntl_other 设置）
const crowdOptions = options.slice()
crowdOptions[15] = { value: 15, label: '国际特征' }
// （目标概况/销售概况/开卡概况/运营概况/会员概况/效率概况）
const operateHeader = [
    // 目标概况
    {
        name: 'target_survey',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Month',
        headerShow: [
            true,
            true,
            false,
            false,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        // time,store,customer,member,passFlow,appointChannel,project,card
        options: options,
        twoRow: false,
    },
    // 会员等级概况
    {
        name: "member_level_overview",
        contrast: false,
        quckTime: "",
        datePicker: "",
        time: "Month",
        headerShow: [
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
        ],
        // 时间，门店，顾客，会员
        options: options
    },
    // 目标分析
    {
        name: 'target_analysis',
        contrast: false,
        quckTime: 'MonthTab',
        datePicker: 'MonthPicker',
        time: '',
        headerShow: [
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: false,
    },
    // 销售概况
    {
        name: 'operate_survey',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Month',
        headerShow: [
            true,
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: false,
    },
    // 销售概况
    {
        name: 'integral_index',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Month',
        headerShow: [
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: false,
    },
    // 销售趋势
    {
        name: 'operate_trend',
        contrast: true,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true, // 销售渠道
            true, //会员类型搜索
        ],
        options: options,
        twoRow: true,
    },
    // LE-3484 单店趋势 复制的 销售趋势
    {
        name: 'single_trend',
        contrast: true,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true, // 销售渠道
        ],
        options: options,
        twoRow: true,
    },
    // LE-5997 人群销售趋势 复制的 销售趋势，新增国际特征（人群）筛选
    {
        name: 'crowd_sales_trend',
        contrast: true,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true, // 销售渠道
            true, // 会员类型搜索
            true, // LE-5997 国际特征（人群）
        ],
        options: crowdOptions,
        twoRow: true,
    },
    // 销售增长
    {
        name: 'operate_target_trend',
        contrast: false,
        quckTime: 'MonthTab',
        datePicker: 'MonthPicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
        ],
        options: options,
        twoRow: true,
    },
    // 客流分析
    {
        name: 'operate_passenger',
        contrast: true,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 客单价
    {
        name: 'operate_price',
        contrast: true,
        quckTime: 'MonthTabFour',
        datePicker: 'MonthPicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 预约分析
    {
        name: 'operate_appoint',
        contrast: true,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 项目分析
    {
        name: 'operate_project_analysis',
        contrast: true,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
        ],
        options: options,
        twoRow: true,
    },
    // 门店对比
    {
        name: 'operate_store',
        contrast: false,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        // 时间，门店，顾客，会员
        options: options,
        twoRow: false,
    },
    // 开卡概况
    {
        name: 'card_survey',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Month',
        headerShow: [
            true,
            true,
            true,
            true,
            true,
            false,
            false,
            true,
            false,
            false,
            false,
            false,
        ],
        // 时间，门店，顾客，会员
        options: options,
        twoRow: false,
    },
    // 积分概况
    {
        name: 'ponit_survey',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Month',
        headerShow: [
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            false,
            false,
            false,
            false,
        ],
        // 时间，门店，顾客，会员
        options: options,
        twoRow: false,
    },
    // 开卡趋势
    {
        name: 'card_trend',
        contrast: true,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            true,
        ],
        // 时间，门店，顾客，会员
        options: cardTrendOptions,
        twoRow: true,
    },
    // 开卡增长
    {
        name: 'card_target_trend',
        contrast: false,
        quckTime: 'MonthTab',
        datePicker: 'MonthPicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
        ],
        options: options,
        twoRow: true,
    },
    // 积分增长
    {
        name: 'integral_analysis',
        contrast: false,
        quckTime: 'MonthTab',
        datePicker: 'MonthPicker',
        time: '',
        headerShow: [
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 充值分析
    {
        name: 'card_price',
        contrast: true,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            true,
            false,
            false,
            false,
            false,
        ],
        options: cardNoCompareOptions,
        twoRow: true,
    },
    // 积分分析
    {
        name: 'integral_goods',
        contrast: false,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 渠道来源分析
    {
        name: 'card_customer',
        contrast: true,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            true,
            false,
            false,
            false,
            false,
        ],
        options: cardNoCompareOptions,
        twoRow: true,
    },
    // 卡对比
    {
        name: 'card_contrast',
        contrast: true,
        quckTime: 'MonthTabTwo',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        // 时间，门店，顾客，会员
        options: options,
        twoRow: false,
    },
    // 门店对比
    {
        name: 'card_store',
        contrast: false,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
        ],
        // 时间，门店，顾客，会员
        options: options,
        twoRow: false,
    },
    // 运营概况
    {
        name: 'run_survey',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Month',
        headerShow: [
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: false,
    },
    // 运营趋势
    {
        name: 'run_trend',
        contrast: true,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 运营增长
    {
        name: 'run_target',
        contrast: false,
        quckTime: 'MonthTab',
        datePicker: 'MonthPicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 服务质量分析
    {
        name: 'run_server',
        contrast: false,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: false,
    },
    // NPS分析
    {
        name: 'run_NPS',
        contrast: false,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: false,
    },
    // 点钟分析
    {
        name: 'run_clock',
        contrast: false,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: false,
    },
    // 打赏分析
    {
        name: 'run_reward',
        contrast: false,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 按摩需求分析
    {
        name: 'run_need',
        contrast: true,
        quckTime: 'MonthTabFour',
        datePicker: 'DatePicker',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        options: options,
        twoRow: true,
    },
    // 门店对比
    {
        name: 'run_store',
        contrast: false,
        quckTime: 'MonthTabTen',
        datePicker: 'DatePicker',
        time: '',
        headerShow: [
            true,
            true,
            true,
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        // 时间，门店，顾客，会员
        options: options,
        twoRow: false,
    },
    // 营运年度目标
    {
        name: 'operation_yearly_target',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Year',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            false,
            false,
            true
        ],
        options: options,
        twoRow: false,
    },
    // 营运季度目标
    {
        name: 'operation_quarterly_target',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'quarter',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            false,
            true
        ],
        startTime: '',
        endTime: '',
        options: options,
        twoRow: false,
    },
    // 营运月度目标
    {
        name: 'operation_monthly_target',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'monthRange',
        startTime: '',
        endTime: '',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            true
        ],
        options: options,
        twoRow: false,
    },


    // 年度目标管理
    {
        name: 'yearly_target_manage',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Year',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            false,
            false,
            false
        ],
        hideSearchType: true,
        options: options,
        twoRow: false,
    },
    // 季度目标管理
    {
        name: 'quarterly_target_manage',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'quarter',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true
        ],
        hideSearchType: true,
        startTime: '',
        endTime: '',
        options: options,
        twoRow: false,
    },
    // 月度目标管理
    {
        name: 'monthly_target_manage',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'monthRange',
        startTime: '',
        endTime: '',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            false
        ],
        hideSearchType: true,
        options: options,
        twoRow: false,
    },

    // 指标季度目标
    {
        name: 'marketing_quarterly_target',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'quarterRange',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            true,
            
        ],
        startTime: '',
        endTime: '',
        options: options,
        twoRow: false,
        isMarketing: true
    },
    // 指标年度目标
    {
        name: 'marketing_yearly_target',
        contrast: false,
        quckTime: '',
        datePicker: '',
        time: 'Year',
        headerShow: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            true,
            false,
            false,
            false,
            false,
            true
        ],
        options: options,
        twoRow: false,
        isMarketing: true
    },
]

const operateContent = [
    // 目标概况
    {
        name: 'target_survey',
        value: [
            {
                name: 'target_survey',
                xname: 'operate',
                selectChart: '',
                selectTable: 'SelectDrop',
                normalTable: 'ColorTables',
                chart: '',
                chartKey: '',
                tableKey: 'target_completion',
                tableTitle: '门店',
                tableAddress: 'bottom',
                tableNum: '3',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                headerType: 3,
                constantKey: '',
                parentID: -1,
                TableconstantType: 8,
                type: 0,
                chartZoom: false,
                isTableKey: true,
                chartNum: '',
                isIndex: true,
                sortIndex: 1,
            },
            {
                xname: 'run',
                chartKey: '',
                tableKey: 'target_comple_OperationAnalysis',
                selectTable: 'SelectDrop',
            },
            {
                xname: 'customer',
                chartKey: '',
                tableKey: 'target_completion_crm',
                selectTable: 'SelectClass',
            },
        ],
    },
    // 会员概况
    {
        name: "member_level_overview",
        value: [
            {
                name: 'member_level_overview',
                xname: 'operate',
                selectChart: '',
                selectTable: 'SelectDrop',
                normalTable: 'ColorTables',
                chart: '',
                chartKey: '',
                tableKey: 'target_member_store_belong',
                tableTitle: '门店',
                tableAddress: 'bottom',
                tableNum: '4',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 4,
                constantKey: '',
                parentID: -1,
                TableconstantType: 8,
                type: 0,
                chartZoom: false,
                isTableKey: true,
                chartNum: '',
                isIndex: true,
                sortIndex: 1,
            },
            {
                xname: "run",
                chartKey: "",
                tableKey: "target_member_relegation",
                selectTable: 'SelectDrop',
                tableAddress: 'bottom',
                tableNum: '3'
            }
        ]
    },
    // 目标分析
    {
        name: 'target_analysis',
        value: [
            {
                name: 'target_analysis',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'ContrantTable',
                oneChart: 'VueColumn',
                chartKey: 'target_analysis_drawing',
                tableKey: 'target_analysis_key_and_table',
                tableTitle: '日期',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                headerType: 2,
                constantKey: '',
                parentID: 0,
                TableconstantType: 3,
                ChartconstantType: 3,
                type: 3,
                dateFormat: 2,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 销售概况
    {
        name: 'operate_survey',
        value: [
            {
                name: 'operate_survey',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'ColorTables',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'indicator_general',
                tableAddress: 'bottom',
                tableNum: '4',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 4,
                constantKey: '',
                parentID: -1,
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 积分概况
    {
        name: 'integral_index',
        value: [
            {
                name: 'integral_index',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'ColorTables',
                oneChart: '',
                chartKey: '',
                tableTitle: '会员等级',
                tableKey: 'point_general_table_key',
                tableAddress: 'bottom',
                tableNum: '4',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 4,
                constantKey: 'member_level',
                parentID: -1,
                TableconstantType: 2,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 销售趋势
    {
        name: 'operate_trend',
        value: [
            {
                name: 'operate_trend',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: 'ContrantTable',
                oneChart: 'VueHighchart',
                chartKey: 'sales_trend',
                tableKey: 'sales_trend',
                tableTitle: '日期',
                chartAddress: '',
                tableAddress: 'bottom',
                chartNum: '2',
                tableNum: '6',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                headerType: 2,
                TableconstantType: 1,
                ChartconstantType: 1,
                constantKey: '',
                parentID: 0,
                type: 0,
                dateFormat: 1,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // LE-3484 单店趋势， 复制的销售趋势
    {
        name: 'single_trend',
        value: [
            {
                name: 'single_trend',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: 'ContrantTable',
                oneChart: 'VueHighchart',
                chartKey: 'sales_trend', // 这个值要修改
                tableKey: 'sales_trend', // 这个值要修改
                tableTitle: '日期',
                chartAddress: '',
                tableAddress: 'bottom',
                chartNum: '2',
                tableNum: '6',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                headerType: 2,
                TableconstantType: 1,
                ChartconstantType: 1,
                constantKey: '',
                parentID: 0,
                type: 0,
                dateFormat: 1,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // LE-5997 人群销售趋势 复制的 销售趋势，chartKey/tableKey 改为 crowd_sales_trend
    {
        name: 'crowd_sales_trend',
        value: [
            {
                name: 'crowd_sales_trend',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: 'ContrantTable',
                oneChart: 'VueHighchart',
                chartKey: 'crowd_sales_trend',
                tableKey: 'crowd_sales_trend',
                tableTitle: '日期',
                chartAddress: '',
                tableAddress: 'bottom',
                chartNum: '2',
                tableNum: '6',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                headerType: 2,
                TableconstantType: 1,
                ChartconstantType: 1,
                constantKey: '',
                parentID: 0,
                type: 0,
                dateFormat: 1,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 销售增长
    {
        name: 'operate_target_trend',
        value: [
            {
                name: 'operate_target_trend',
                xname: 'RatioOne',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'ContrantTable',
                oneChart: 'VueColumn',
                chartKey: 'mom_goals_and_growth',
                tableKey: 'mom_goals_and_growth',
                chartAddress: 'center',
                tableAddress: 'bottom',
                chartNum: '1',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                headerType: 2,
                constantKey: '',
                parentID: 0,
                tableTitle: '日期',
                TableconstantType: 3,
                ChartconstantType: 3,
                type: 2,
                dateFormat: 2,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                IndexCompareType: 1,
                sortIndex: 1,
            },
            {
                xname: 'RatioTwo',
                chartKey: 'yoy_goals_and_growth',
                tableKey: 'yoy_goals_and_growth',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                type: 1,
                headerType: 2,
                normalTable: 'ContrantTable',
            },
            {
                xname: 'standard',
                chartKey: 'bench_table_goals_growth',
                tableKey: 'bench_table_goals_growth',
                type: 4,
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                headerType: 1,
                normalTable: 'OneLevel',
            },
        ],
    },
    // 客流分析
    {
        name: 'operate_passenger',
        value: [
            {
                name: 'operate_passenger',
                xname: 'PassFlow',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                tableTitle: '接触客次',
                chartAddress: 'center',
                tableAddress: 'bottom',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: 'custflow_analysis_custflow_analysis',
                chartKey: 'custflow_custflow_analysis_drawing',
                tableKey: 'custflow_custflow_analysis_table_key',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                // type: 2,
                dateFormat: 1,
                isIndex: true,
                ascending: 0,
                sortIndex: 1,
            },
            {
                xname: 'Class',
                tableTitle: '顾客类型',
                chartKey: 'customer_type_drawing',
                tableKey: 'customer_type_table_key',
                constantKey: 'new_or_old_customer',
                isTime: true,
                chartNum: '1',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                isTwo: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                // type: 2,
                ChartconstantType: 4,
                parentID: -1,
                ascending: 0,
            },
            {
                xname: 'Member',
                tableTitle: '会员类型',
                chartKey: 'member_type_drawing',
                tableKey: 'member_type_table_key',
                constantKey: 'customerType',
                isTime: true,
                chartNum: '1',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                isTwo: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                ChartconstantType: 4,
                parentID: -1,
                // type: 2,
                ascending: 0,
            },
            {
                xname: 'ComeStore',
                tableTitle: '客流渠道',
                chartKey: 'reach_store_channel_drawing',
                tableKey: 'reach_store_channel_table_key',
                constantKey: 'reach_store_book_source',
                isTime: true,
                chartNum: '1',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                isTwo: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                ChartconstantType: 4,
                parentID: -1,
                // type: 2,
                ascending: 0,
            },
            {
                xname: 'AccomNum',
                tableTitle: '同行人数',
                chartKey: 'accompany_number_drawing',
                tableKey: 'accompany_number_table_key',
                constantKey: 'dimensionality_accompanyNumber',
                isTime: true,
                chartNum: '1',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                isTwo: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                ChartconstantType: 4,
                parentID: -1,
                // type: 2,
                ascending: 0,
            },
            {
                xname: 'ComeTime',
                tableTitle: '时间分布',
                chartKey: 'reach_store_timelen_drawing',
                tableKey: 'reach_store_timelen_table_key',
                isTime: false,
                chartNum: '2',
                oneChart: 'VueColumn',
                firstChart: '',
                secondChart: '',
                isTwo: false,
                constantKey: 'dimensionality_reachStoreTime',
                ChartconstantType: 2,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                normalTable: 'OneTable',
                parentID: -1,
                chartSort: false,
                sortIndex: 1,
                ascending: 1,
            },
            {
                xname: 'ComeDay',
                tableTitle: '星期分布',
                normalTable: 'OneTable',
                chartKey: 'weekday_custflow_drawing',
                tableKey: 'weekday_custflow_table_key',
                isTime: false,
                chartNum: '2',
                oneChart: 'VueColumn',
                firstChart: '',
                secondChart: '',
                isTwo: false,
                constantKey: 'dimensionality_weekDayCustFlow',
                ChartconstantType: 2,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                parentID: -1,
                sortIndex: 1,
                ascending: 1,
            },
            {
                xname: 'Percent',
                chartTitle: '预约表客次',
                chartKey: 'cust_time_of_busy_spare_analysis',
                tableKey: 'cust_time_of_busy_spare_analysis',
                isTime: false,
                isTwo: false,
                chartNum: '1',
                oneChart: 'ChartHeatmap',
                isTable: true,
                isChart: true,
                chartZoom: false,
                isTableKey: false,
                constantKey: 'period_time_of_busy_spare_analysis',
                constantKeyAxis: 'dimensionality_weekDayCustFlow',
            },
            {
                xname: 'NotChange',
                tableTitle: '转换分析',
                chartKey: 'cannot_recieved_analysis_drawing',
                tableKey: 'cannot_recieved_analysis_drawing',
                isTime: false,
                isTwo: true,
                oneChart: 'VuePie',
                constantKey: 'cannot_be_received_transform',
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: 'VuePie',
                secondChart: 'VuePie',
                type: 1,
                chartZoom: true,
                isTableKey: true,
                parentID: 0,
                compareChart: 'VuePie2',
                ascending: 0,
            },
        ],
    },
    // 客单价
    {
        name: 'operate_price',
        value: [
            {
                name: 'operate_price',
                xname: 'AfterPrice',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey: 'discount_unit_price_distribute_drawing',
                tableKey: 'discount_unit_price_distribute_table',
                tableTitle: '客单价',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: 'persion_unit_price_constant',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                sqlType: 2,
                isIndex: true,
            },
            {
                xname: 'BeforePrice',
                sqlType: 1,
                chartKey: 'discount_unit_price_distribute_drawing',
                tableKey: 'discount_unit_price_distribute_table',
            },
            // LE-3456
            {
                xname: 'AfterPrice111',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey: 'discount_unit_price_distribute_customer_drawing',
                tableKey: 'discount_unit_price_distribute_customer',
                indicatorKey: 'discount_unit_price_distribute_customer',
                tableTitle: '客单价',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: 'persion_unit_price_constant',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                sqlType: 2,
                isIndex: true,
            },
        ],
    },
    // 预约分析
    {
        name: 'operate_appoint',
        value: [
            {
                name: 'operate_appoint',
                xname: 'AppointTrend',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'OneTable',
                compareTable: 'OneLevel',
                oneChart: 'VueHighchart',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'book_trend_of_book_analysis_drawing',
                tableKey: 'book_trend_of_of_book_analysis_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableTitle: '日期',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: '',
                headerType: 1,
                parentID: -1,
                TableconstantType: 1,
                ChartconstantType: 1,
                type: 0,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
                bookSource:-1,
            },
            {
                xname: 'AppointTime',
                chartKey: 'ahead_book_timelen_drawing',
                tableKey: 'ahead_book_timelen_table_key',
                isTime: false,
                oneChart: 'VueColumn',
                normalTable: 'TableCard',
                TableconstantType: 2,
                ChartconstantType: 2,
                isTwo:false,
                chartNum: '2',
                constantKey: 'dimensionality_aheadBookTimeLen',
                tableTitle: '时长',
                bookSource:-1,
            },
            {
                xname: 'CancelTime',
                chartKey: 'ahead_cancel_timelen_drawing',
                tableKey: 'ahead_cancel_timelen_table_key',
                isTime: false,
                ChartconstantType: 2,
                TableconstantType: 2,
                isTwo:false,
                chartNum: '1',
                oneChart: 'VueColumn',
                firstChart:'',
                secondChart:'',
                normalTable: 'TableCard',
                constantKey: 'dimensionality_aheadCancelTimeLen',
                tableTitle: '时长',
            },
            {
                xname: 'WxRecommend',
                chartKey: 'wx_recommand_store_drawing',
                tableKey: 'wx_recommand_store_table_key',
                ChartconstantType: 1,
                TableconstantType: 1,
                oneChart: 'VueHighchart',
                firstChart:'',
                isTwo:false,
                secondChart:'',
                chartNum: '2',
                isTime: true,
                constantKey: '',
                tableTitle: '日期',
                bookSource:-1,
            },{
                xname: 'WeixinAnalysis',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'Funnel',
                secondChart: 'AsideTrend',
                compareChart: '',
                chartKey:
                    'funnel_transfer_wxbook_funnel_drawing',
                tableKey:
                    'wxbook_transfer_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '指标',
                chartZoom: true,
                isTableKey: true,
                constantKey: 'wxbook_transfer_funnel_dimension',
                headerType: 1,
                parentID: -1,
                TableconstantType: 8,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                isIndex: true,
                bookSource:2
            },{
                xname: 'PhoneAnalysis',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'Funnel',
                secondChart: 'AsideTrend',
                compareChart: '',
                chartKey:
                    'funnel_transfer_telphonebook_funnel_drawing',
                tableKey:
                    'telphonebook_transfer_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '指标',
                chartZoom: true,
                isTableKey: true,
                constantKey: 'telphonebook_transfer_funnel_dimension',
                headerType: 1,
                parentID: -1,
                TableconstantType: 8,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                isIndex: true,
                bookSource:0
            }
        ],
    },
    // 项目分析
    {
        name: 'operate_project_analysis',
        value: [
            {
                name: 'operate_project_analysis',
                xname: 'OperateProject',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'OneTable',
                compareTable: 'OneLevel',
                oneChart: 'VueHighchart',
                firstChart: '',
                secondChart: '',
                compareChart: 'VueHighchart',
                chartKey: 'items_trend_drawing',
                tableKey: 'items_trend',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableTitle: '日期',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: '',
                headerType: 1,
                parentID: 0,
                TableconstantType: 1,
                ChartconstantType: 1,
                type: 0,
                dateFormat: 1,
                sqlType: 2,
                isIndex: true,
                sortIndex: 1,
            },
            {
                xname: 'Class',
                chartKey: 'item_category_of_items_analysis_pie',
                tableKey: 'item_category_of_items_analysis_table_key',
                isTime: false,
                isTwo: true,
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: 'VuePie',
                secondChart: 'VuePie',
                PieconstantType: 6,
                TableconstantType: 6,
                tableTitle: '项目分类',
                queryKey: 'categoryID',
                constantKey: '',
                type: 1,
                compareChart: 'VuePie2',
                sortIndex: 1,
            },
            {
                xname: 'Times',
                chartKey: 'item_timeLen_of_items_analysis_pie',
                tableKey: 'item_timeLen_of_items_analysis_table_key',
                isTime: false,
                isTwo: true,
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: 'VuePie',
                secondChart: 'VuePie',
                PieconstantType: 7,
                TableconstantType: 7,
                tableTitle: '项目时长',
                queryKey: 'timeLength',
                constantKey: '',
                type: 1,
                compareChart: 'VuePie2',
                sortIndex: 1,
            },
            {
                xname: 'Price',
                chartKey: 'item_price_of_items_analysis_pie',
                tableKey: 'item_price_of_items_analysis_pie',
                isTime: false,
                isTwo: true,
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: 'VuePie',
                secondChart: 'VuePie',
                PieconstantType: 2,
                TableconstantType: 2,
                tableTitle: '项目价格',
                queryKey: 'price',
                constantKey: 'productPrice',
                type: 1,
                compareChart: 'VuePie2',
                sortIndex: 1,
            },
        ],
    },
    // 门店对比
    {
        name: 'operate_store',
        value: [
            {
                name: 'operate_store',
                xname: 'index',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: '',
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'store_compare_of_sales_analysis',
                tableKey: 'store_compare_of_sales_analysis',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                tableTitle: '门店',
                chartZoom: true,
                isTableKey: true,
                constantKey: '',
                headerType: 2,
                parentID: -1,
                TableconstantType: 8,
                ChartconstantType: 8,
                type: 0,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },

    {
        name: 'card_contrast',
        value: [
            {
                name: 'card_contrast',
                xname: 'cardContrast',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: '',
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'card_compare_name_of_open_analysis_drawing',
                tableKey: 'card_compare_name_of_open_analysis_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: '',
                headerType: 2,
                parentID: -1,
                TableconstantType: 14,
                ChartconstantType: 14,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
            },

            {
                xname: 'cardType',
                chartKey: 'card_compare_of_open_card_analysis_pie',
                tableKey: 'card_compare_of_open_card_analysis_table_key',
                isTime: false,
                isTwo: true,
                headerType: 1,
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: 'VuePie',
                secondChart: 'VuePie',
                PieconstantType: 15,
                TableconstantType: 15,
                queryKey: 'cardType',
                constantKey: '',
                type: 1,
                compareChart: 'VuePie2',
                sortIndex: 1,
            },
        ],
    },

    // 开卡概况
    {
        name: 'card_survey',
        value: [
            {
                name: 'card_survey',
                xname: 'Summarys',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'ColorTables',
                compareTable: '',
                oneChart: '',
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: '',
                tableKey: 'open_card_general_of_open_card_analysis',
                chartAddress: '',
                tableAddress: 'bottom',
                tableNum: '4',
                chartNum: '',
                tableTitle: '门店',
                focus: 2,
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                headerType: 4,
                constantKey: '',
                parentID: -1,
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
            },
            {
                tableTitle: '售卡名称',
                xname: 'saleCard',
                tableKey: 'open_card_general_detail_of_open_card_analysis',
                TableconstantType: 14,
            },
        ],
    },
    // 积分概况
    {
        name: 'ponit_survey',
        value: [
            {
                name: 'ponit_survey',
                xname: 'Summarys',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'ColorTables',
                compareTable: '',
                oneChart: '',
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: '',
                tableKey: 'point_general_table_key',
                chartAddress: '',
                tableAddress: 'bottom',
                tableNum: '4',
                chartNum: '1',
                tableTitle: '门店',
                focus: 2,
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                headerType: 4,
                constantKey: '',
                parentID: -1,
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
            },
            {
                tableTitle: '售卡名称',
                xname: 'saleCard',
                tableKey: 'open_card_general_detail_of_open_card_analysis',
                TableconstantType: 14,
            },
        ],
    },
    // 开卡趋势
    {
        name: 'card_trend',
        value: [
            {
                name: 'card_trend',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: 'ContrantTable',
                oneChart: 'VueHighchart',
                chartKey: 'open_card_trend_of_open_card_drawing',
                tableKey: 'open_card_trend_of_open_card_table_key',
                chartAddress: '',
                tableAddress: 'bottom',
                chartNum: '2',
                tableNum: '6',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '日期',
                headerType: 2,
                TableconstantType: 1,
                ChartconstantType: 1,
                constantKey: '',
                parentID: 0,
                type: 0,
                dateFormat: 1,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 开卡增长
    {
        name: 'card_target_trend',
        value: [
            {
                name: 'card_target_trend',
                xname: 'RatioOne',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'ContrantTable',
                oneChart: 'VueColumn',
                chartKey: 'open_card_mom_of_open_card_drawing',
                tableKey: 'open_card_mom_of_open_card_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableTitle: '日期',
                chartNum: '1',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                headerType: 2,
                constantKey: '',
                parentID: 0,
                TableconstantType: 3,
                ChartconstantType: 3,
                IndexCompareType: 1,
                type: 2,
                dateFormat: 2,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
            {
                xname: 'RatioTwo',
                chartKey: 'open_card_yoy_of_open_card_drawing',
                tableKey: 'open_card_yoy_of_open_card_table_key',
                type: 1,
            },
            {
                xname: 'standard',
                chartKey: 'open_card_bench_of_open_card_drawing',
                tableKey: 'open_card_bench_of_open_card_table_key',
                type: 4,
            },
        ],
    },
    // 开卡增长
    {
        name: 'integral_analysis',
        value: [
            {
                name: 'integral_analysis',
                xname: 'RatioOne',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'ContrantTable',
                oneChart: 'VueColumn',
                chartKey: 'point_mom_of_point_drawing',
                tableKey: 'point_mom_of_point_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableTitle: '日期',
                chartNum: '1',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                headerType: 2,
                constantKey: '',
                parentID: 0,
                TableconstantType: 3,
                ChartconstantType: 3,
                IndexCompareType: 1,
                type: 2,
                dateFormat: 2,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
            {
                xname: 'RatioTwo',
                chartKey: 'open_card_yoy_of_open_card_drawing',
                tableKey: 'open_card_yoy_of_open_card_table_key',
                type: 1,
            },
            {
                xname: 'standard',
                chartKey: 'open_card_bench_of_open_card_drawing',
                tableKey: 'open_card_bench_of_open_card_table_key',
                type: 4,
            },
        ],
    },
    // 充值分析
    {
        name: 'card_price',
        value: [
            {
                name: 'card_price',
                xname: 'CardType',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey:
                    'card_type_distribution_of_open_card_analysis_chart_key',
                tableKey:
                    'card_type_distribution_of_open_card_analysis_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '充值卡类型',
                chartZoom: true,
                isTableKey: true,
                constantKey: 'card_type',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                isIndex: true,
            },

            {
                name: 'card_price',
                xname: 'MemberCard',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey: 'stored_value_type_of_recharge_analysis_drawing',
                tableKey: 'stored_value_type_of_recharge_analysis_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '充值卡类型',
                chartZoom: true,
                isTableKey: true,
                constantKey: 'stored_value_card_type',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                isIndex: true,
            },

            {
                xname: 'TimeCard',
                chartKey: 'times_card_of_open_card_analysis_pie',
                tableKey: 'times_card_of_open_card_analysis_table_key',
                constantKey: 'stored_value_card_type',
                isTime: true,
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                isTwo: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                TableconstantType: 16,
                PieconstantType: 16,
                ChartconstantType: 16,
                isIndex: true,
            },

            {
                xname: 'ContinueRatio',
                chartKey: 'recharge_or_no_recharge_analysis_drawing',
                tableKey: 'recharge_or_no_recharge_analysis_table_key',
                constantKey: 'recharge_no_recharge_of_recharge_analy_dimen',
                isTime: true,
                tableTitle: '续充/未续充',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                isTwo: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                isIndex: true,
            },

            {
                xname: 'NewCard',
                chartKey: 'new_or_continue_recharge_drawing',
                tableKey: 'new_or_continue_recharge_table_key',
                constantKey: 'new_continue_recharge_of_recharge_analysis',
                isTime: true,
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                tableTitle: '新充续充',
                isTwo: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                isIndex: true,
                isChartkey: true,
            },

            {
                xname: 'ChangeTime',
                chartKey: 'consume_times_before_recharge_drawing',
                tableKey: 'consume_times_before_recharge_table_key',
                isTime: false,
                constantKey: 'consume_times_before_recharge',
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                isTwo: false,
                ChartconstantType: 2,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                tableTitle: '消费次数',
                isIndex: true,
            },
            // {
            //   xname: 'NewProgress',
            //   oneChart: 'Sangkey',
            //   tableKey: 'open_card_transfer_path_drawing',
            //   chartKey: 'open_card_transfer_path_drawing',
            //   isTime: false,
            //   isTwo: false,
            //   isTable: true,
            //   chartZoom: false,
            //   isTableKey: false,
            //   isIndex: false,
            //   firstChart: ''
            // },
            // {
            //   xname: 'ProjectProgress',
            //   oneChart: 'Sangkey',
            //   tableKey: 'item_open_card_transfer_path_drawing',
            //   chartKey: 'item_open_card_transfer_path_drawing',
            //   isTime: false,
            //   isTwo: false,
            //   isTable: true,
            //   chartZoom: false,
            //   isTableKey: false,
            //   isIndex: false,
            //   firstChart: ''
            // },
            {
                xname: 'Remain',
                chartKey: 'balance_of_continue_recharge_drawing',
                tableKey: 'balance_of_continue_recharge_table_key',
                constantKey: 'balance_of_continue_recharge_dimension',
                isTime: false,
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                tableTitle: '余额分布',
                isTwo: false,
                ChartconstantType: 2,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
            },
        ],
    },
    // 积分分析
    {
        name: 'integral_goods',
        value: [
            {
                name: 'integral_goods',
                xname: 'pointAnalysisOne',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey:
                    'point_get_distribution_of_point_get_distribution_chart_key',
                tableKey:
                    'point_get_distribution_of_point_get_distribution_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '积分发放分布',
                chartZoom: true,
                isTableKey: true,
                constantKey: 'point_source_type',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                isIndex: true,
            },
            {
                name: 'integral_goods',
                xname: 'pointAnalysisTwo',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey: 'point_consume_distribution_of_point_consume_distribution_chart_key',
                tableKey: 'point_consume_distribution_of_point_consume_distribution_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '积分消耗分析',
                chartZoom: true,
                isTableKey: true,
                constantKey: 'point_event_type',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                type: 0,
                dateFormat: 1,
                isIndex: true,
            },

            {
                xname: 'pointAnalysisThree',
                chartKey: 'point_range_drawing',
                tableKey: 'point_range_table_key',
                constantKey: 'point_range',
                isTime: false,
                tableTitle: '客户可用积分累计统计',
                oneChart: 'VueColumn',
                firstChart: 'VueColumn',
                secondChart: '',
                isTwo: false,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 2,
                isIndex: true,
            },

            {
                xname: 'pointAnalysisFour',
                chartKey: 'point_member_range_drawing',
                tableKey: 'point_member_range_table_key',
                constantKey: 'member_level_V2',
                isTime: false,
                oneChart: 'VueColumn',
                firstChart: 'VueColumn',
                secondChart: '',
                tableTitle: '会员身份积分累计统计',
                isTwo: false,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 2,
                isIndex: true,
                isChartkey: true,
            },
            {
                name: 'integral_goods',
                xname: 'pointAnalysisFive',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey:
                    'point_payment_distribution_of_point_payment_distribution_chart_key',
                tableKey:
                    'point_payment_distribution_of_point_payment_distribution_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                tableTitle: '支付获取积分明细',
                chartZoom: true,
                isTableKey: true,
                headerType: 1,
                parentID: -1,
                TableconstantType: 20,
                PieconstantType: 20,
                ChartconstantType: 20,
                type: 0,
                dateFormat: 1,
                isIndex: true,
            }
        ],
    },
    // 渠道来源分析
    {
        name: 'card_customer',
        value: [
            {
                name: 'card_customer',
                xname: 'Resource',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'cust_source_of_stored_value_member_drawing',
                tableKey: 'cust_source_of_stored_value_member_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                constantKey: 'customer_source_channel',
                ChartconstantType: 2,
                TableconstantType: 2,
                chartZoom: true,
                isTableKey: true,
                headerType: 1,
                parentID: -1,
                dateFormat: 1,
                isIndex: true,
                tableTitle: '新客渠道',
            },
            {
                xname: 'NewProgress',
                oneChart: 'Sangkey',
                tableKey: 'open_card_transfer_path_drawing',
                chartKey: 'open_card_transfer_path_drawing',
                constantKey: 'new_cust_channel_recharge_ana',
                constantKey1: 'unit_price_channel_recharge_ana',
                constantKey2: 'recharge_amt_channel_recharge_ana',
                isTime: false,
                isTwo: false,
                isTable: true,
                chartZoom: false,
                isTableKey: false,
                isIndex: false,
                chartNum: '1',
            },
            {
                xname: 'ProjectProgress',
                oneChart: 'Sangkey',
                tableKey: 'item_open_card_transfer_path_drawing',
                chartKey: 'item_open_card_transfer_path_drawing',
                constantKey: 'new_cust_channel_recharge_ana',
                constantKey1: 'item_transfer_open_card_item',
                constantKey2: 'recharge_amt_channel_recharge_ana',
                isTime: false,
                isTwo: false,
                isTable: true,
                chartZoom: false,
                isTableKey: false,
                isIndex: false,
                chartNum: '1',
            },
        ],
    },
    // 门店对比
    {
        name: 'card_store',
        value: [
            {
                name: 'card_store',
                xname: 'index',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: '',
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'store_compare_of_open_card_analysis_drawing',
                tableKey: 'store_compare_of_open_card_analysis_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                tableTitle: '门店',
                chartZoom: true,
                isTableKey: true,
                constantKey: '',
                headerType: 2,
                parentID: -1,
                TableconstantType: 8,
                ChartconstantType: 8,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },

    // 门店对比

    // 运营概况
    {
        name: 'run_survey',
        value: [
            {
                name: 'run_survey',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'ColorTables',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'operation_general_of_operation_analysis',
                tableAddress: 'bottom',
                tableNum: '4',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 4,
                constantKey: '',
                parentID: -1,
                TableconstantType: 8,
                type: 1,
                dateFormat: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 运营趋势
    {
        name: 'run_trend',
        value: [
            {
                name: 'run_trend',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: 'ContrantTable',
                oneChart: 'VueHighchart',
                chartKey: 'operation_trend',
                tableKey: 'operation_trend',
                chartAddress: '',
                tableTitle: '日期',
                tableAddress: 'bottom',
                chartNum: '2',
                tableNum: '6',
                isTwo: false,
                isDay: true,
                isTime: true,
                isChart: true,
                isTable: true,
                headerType: 2,
                TableconstantType: 1,
                ChartconstantType: 1,
                constantKey: '',
                parentID: 0,
                type: 0,
                dateFormat: 1,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 运营增长
    {
        name: 'run_target',
        value: [
            {
                name: 'run_target',
                xname: 'RatioOne',
                normalTable: 'ContrantTable',
                oneChart: 'VueColumn',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                chartKey: 'mom_goals_growth_operation',
                tableKey: 'mom_goals_growth_operation',
                chartAddress: 'center',
                tableAddress: 'bottom',
                chartNum: '1',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                headerType: 2,
                constantKey: '',
                parentID: 0,
                TableconstantType: 3,
                ChartconstantType: 3,
                IndexCompareType: 1,
                type: 2,
                dateFormat: 2,
                chartZoom: true,
                isTableKey: true,
                isIndex: true,
                tableTitle: '日期',
                sortIndex: 1,
            },
            {
                xname: 'RatioTwo',
                chartKey: 'yoy_goals_growth_operation',
                tableKey: 'yoy_goals_growth_operation',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                type: 1,
                headerType: 2,
                normalTable: 'ContrantTable',
            },
            {
                xname: 'standard',
                chartKey: 'compare_goals_growth_operation',
                tableKey: 'compare_goals_growth_operation',
                type: 4,
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                headerType: 1,
                normalTable: 'OneLevel',
            },
        ],
    },
    // 服务质量分析
    {
        name: 'run_server',
        value: [
            {
                name: 'run_server',
                xname: 'server',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: '',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey: 'skill_evaluation_drawing',
                tableKey: 'skill_evaluation_table_key',
                tableTitle: '评价星级',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: 'dimen_evaluation_stars',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                // type: 2,
                dateFormat: 1,
                isIndex: true,
            },
            {
                xname: 'customClass',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: '',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: 'VuePie',
                chartKey: 'customer_type_service_quality_drawing',
                tableKey: 'customer_type_service_quality_table_key',
                tableTitle: '客户类型',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: 'dimen_memberType_operation',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                // type: 2,
                dateFormat: 1,
                isIndex: true,
                indicator: 'indicatorIDs'
            },
            {
                xname: 'wordCloud',
                chartKey: 'order_evaluation_remark_analysis',
                constantKey: 'order_evaluation_remark_analysis',
                isTime: false,
                isTwo: false,
                isIndex: false,
                isTable: false,
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: '',
                oneChart: 'WordCloud',
                secondChart: '',
                PieconstantType: 2,
                TableconstantType: 2,
                tableTitle: '订单评价内容分析',
                queryKey: 'npsType',
                parentID: 0,
                indicator: '',
            },
            {
                xname: 'tagsAnalysis',
                chartKey: 'evaluation_tags_analysis',
                constantKey: 'evaluation_tags_analysis',
                isTime: false,
                isTwo: false,
                isIndex: false,
                isTable: false,
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: '',
                oneChart: 'treeChart',
                secondChart: '',
                PieconstantType: 2,
                TableconstantType: 2,
                tableTitle: '订单评价内容分析',
                queryKey: 'npsType',
                parentID: 0,
                indicator: '',
            },
            //   {
            //     xname: "evaluate",
            //     chartKey: "evaluation_channel_drawing",
            //     tableKey: "evaluation_channel_table_key",
            //     constantKey: "dimen_evaluation_channel",
            //     tableTitle: "评价渠道"
            //   },
            //   {
            //     xname: "customClass",
            //     chartKey: "customer_type_service_quality_drawing",
            //     tableKey: "customer_type_service_quality_table_key",
            //     constantKey: "dimen_memberType_operation",
            //     tableTitle: "客户类型"
            //   },
        ],
    },
    // NPS分析
    {
        name: 'run_NPS',
        value: [
            {
                name: 'run_NPS',
                xname: 'Trend',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'OneTable',
                compareTable: '',
                oneChart: 'VueHighchart',
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'trend_of_nps',
                tableKey: 'trend_of_nps',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableTitle: '日期',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: '',
                headerType: 1,
                parentID: 0,
                TableconstantType: 1,
                ChartconstantType: 1,
                type: 0,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
            },
            {
                xname: 'Distribute',
                chartKey: 'distribution_of_nps_drawing',
                tableKey: 'distribution_of_nps_table_key',
                constantKey: 'classification_of_nps',
                isTime: false,
                isTwo: true,
                chartNum: '1',
                normalTable: 'TableAnalysis',
                firstChart: 'VuePie',
                secondChart: 'VuePie',
                PieconstantType: 2,
                TableconstantType: 2,
                tableTitle: '分值分布',
                queryKey: 'npsType',
                parentID: 0,
            },
            {
                xname: 'CustomClass',
                chartKey: 'cust_type_of_nps_drawing',
                tableKey: 'cust_type_of_nps_table_key',
                normalTable: 'TableCard',
                isTime: true,
                chartNum: '1',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                tableTitle: '客户类型',
                isTwo: true,
                constantKey: 'customer_type_of_nps',
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                dateFormat: 1,
                parentID: -1,
                queryKey: 'npsType',
            },
        ],
    },
    // 点钟分析
    {
        name: 'run_clock',
        value: [
            {
                name: 'run_clock',
                xname: 'Class',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: '',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: '',
                chartKey: 'cust_type_of_timesheet_drawing',
                tableKey: 'cust_type_of_timesheet_table_key',
                tableTitle: '会员类型',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: 'customer_type_of_timesheet',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                dateFormat: 1,
                isIndex: true,
            },
        ],
    },
    // 打赏分析
    {
        name: 'run_reward',
        value: [
            {
                name: 'run_reward',
                xname: 'RewardChannel',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: '',
                oneChart: '',
                firstChart: 'VuePie',
                secondChart: 'AsideTrend',
                compareChart: '',
                chartKey: 'reward_analysis_drawing',
                tableKey: 'reward_analysis_table_key',
                tableTitle: '打赏渠道',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: true,
                isDay: false,
                isTime: true,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                constantKey: 'reward_channel_of_reward_analysis',
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                PieconstantType: 2,
                ChartconstantType: 4,
                dateFormat: 1,
                isIndex: true,
            },
            {
                xname: 'RewardMoney',
                tableTitle: '打赏金额',
                chartKey: 'reward_money_analysis_drawing',
                tableKey: 'reward_money_analysis_table_key',
                constantKey: 'reward_money_of_reward_analysis',
            },
            {
                xname: 'CustomerClass',
                tableTitle: '顾客类型',
                chartKey: 'reward_cust_type_analysis_drawing',
                tableKey: 'reward_cust_type_analysis_table_key',
                constantKey: 'dimen_memberType_operation',
            },
        ],
    },
    // 按摩需求分析
    {
        name: 'run_need',
        value: [
            {
                name: 'run_need',
                xname: 'Fatigue',
                selectChart: 'SelectIndex',
                selectTable: 'SelectDrop',
                normalTable: 'TableCard',
                compareTable: 'OneLevel',
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'physical_fatigue_of_massage_drawing',
                tableKey: 'physical_fatigue_of_massage_table_key',
                constantKey: 'physical_fatigue_of_massage_dimension',
                tableTitle: '身体部位',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '1',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                chartZoom: true,
                isTableKey: true,
                headerType: 1,
                parentID: -1,
                TableconstantType: 2,
                ChartconstantType: 2,
                dateFormat: 1,
                isIndex: true,
            },
            {
                xname: 'Strength',
                tableTitle: '力度',
                chartKey: 'power_prefer_of_massage_drawing',
                tableKey: 'power_prefer_of_massage_table_key',
                constantKey: 'power_prefer_of_massage_dimension',
            },
            {
                xname: 'frequency',
                tableTitle: '按摩频次',
                chartKey: 'massage_frequency_of_massage_drawing',
                tableKey: 'massage_frequency_of_massage_table_key',
                constantKey: 'massage_frequency_of_massage_dimension',
            },
            {
                xname: 'Character',
                tableTitle: '顾客特征',
                chartKey: 'cust_feature_of_massage_drawing',
                tableKey: 'cust_feature_of_massage_table_key',
                constantKey: 'cust_feature_of_massage_dimension',
            },
            {
                xname: 'Reason',
                tableTitle: '按摩预原因',
                chartKey: 'reason_of_massage_drawing',
                tableKey: 'reason_of_massage_table_key',
                constantKey: 'reason_of_massage_dimension',
            },
            // {
            //   xname: 'frequency',
            //   chartKey: 'reward_analysis_drawing',
            //   tableKey: 'reward_analysis_table_key'
            // }
        ],
    },
    // 门店对比
    {
        name: 'run_store',
        value: [
            {
                name: 'run_store',
                xname: 'index',
                selectChart: 'SelectChart',
                selectTable: 'SelectClass',
                normalTable: 'DateTable',
                compareTable: '',
                oneChart: 'VueColumn',
                chartSort: true,
                firstChart: '',
                secondChart: '',
                compareChart: '',
                chartKey: 'store_compare_of_operation_analysis_drawing',
                tableKey: 'store_compare_of_operation_analysis_table_key',
                chartAddress: 'center',
                tableAddress: 'bottom',
                tableNum: '6',
                chartNum: '2',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: true,
                isTable: true,
                tableTitle: '门店',
                chartZoom: true,
                isTableKey: true,
                constantKey: '',
                headerType: 2,
                parentID: -1,
                TableconstantType: 8,
                ChartconstantType: 8,
                dateFormat: 1,
                isIndex: true,
                sortIndex: 1,
            },
        ],
    },
    // 营运年度目标
    {
        name: 'operation_yearly_target',
        value: [
            {
                name: 'operation_yearly_target',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'operation_yearly_target',
                tableAddress: 'bottom',
                tableNum: '8',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                month: '',
                parentID: -1,
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 3,
                areaType: 1
            },
        ],
    },
    // 营运季度度目标
    {
        name: 'operation_monthly_target',
        value: [
            {
                name: 'operation_monthly_target',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'operation_monthly_target',
                tableAddress: 'bottom',
                tableNum: '8',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                parentID: -1,
                startTime: '',
                endTime: '',
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 1,
                areaType: 1
            },
        ],
    },
    // 营运季度目标
    {
        name: 'operation_quarterly_target',
        value: [
            {
                name: 'operation_quarterly_target',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'operation_quarterly_target',
                tableAddress: 'bottom',
                tableNum: '8',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                parentID: -1,
                startTime: '',
                endTime: '',
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 2,
                areaType: 1
            },
        ],
    },
    // 年度目标管理
    {
        name: 'yearly_target_manage',
        value: [
            {
                name: 'yearly_target_manage',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'yearly_target_manage',
                tableAddress: 'bottom',
                tableNum: '8',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                month: '',
                parentID: -1,
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 3,
                areaType: 1
            },
        ],
    },
    // 季度目标管理
    {
        name: 'quarterly_target_manage',
        value: [
            {
                name: 'quarterly_target_manage',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'quarterly_target_manage',
                tableAddress: 'bottom',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                parentID: -1,
                startTime: '',
                endTime: '',
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 1,
                areaType: 1
            },
        ],
    },
    // 月度目标管理
    {
        name: 'monthly_target_manage',
        value: [
            {
                name: 'monthly_target_manage',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'monthly_target_manage',
                tableAddress: 'bottom',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                parentID: -1,
                startTime: '',
                endTime: '',
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 2,
                areaType: 1
            },
        ],
    },
    // 指标季度目标
    {
        name: 'marketing_quarterly_target',
        value: [
            {
                name: 'marketing_quarterly_target',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'marketing_quarterly_target',
                tableAddress: 'bottom',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                parentID: -1,
                startTime: '',
                endTime: '',
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 2,
                areaType: 1,
                isMarketing: true
            },
        ],
    },
    // 营运年度目标
    {
        name: 'marketing_yearly_target',
        value: [
            {
                name: 'marketing_yearly_target',
                selectChart: '',
                selectTable: 'SelectClass',
                normalTable: 'IndexTable',
                oneChart: '',
                chartKey: '',
                tableTitle: '门店',
                tableKey: 'marketing_yearly_target',
                tableAddress: 'bottom',
                tableNum: '6',
                isTwo: false,
                isDay: false,
                isTime: false,
                isChart: false,
                isTable: true,
                focus: 2,
                headerType: 5,
                constantKey: '',
                month: '',
                parentID: -1,
                TableconstantType: 8,
                type: 1,
                chartZoom: false,
                isTableKey: true,
                isIndex: true,
                sortIndex: 1,
                timelyType: 3,
                areaType: 1
            },
        ],
    },
]

export { operateHeader, operateContent }
